import { Component, HostListener, OnInit, SimpleChanges } from '@angular/core';
import { BaseComponent } from 'src/app/core/abstracts/base.component';

@Component({
  selector: 'app-virtual',
  templateUrl: './virtual.component.html',
  styleUrls: ['./virtual.component.scss']
})
export class VirtualComponent extends BaseComponent implements OnInit {


  statu: string = null;
  scrHeight: any;
  scrWidth: any;

  

  ngOnInit() {

    this.routeStateService.virtualPage.subscribe(studentInfo => {

      if (studentInfo) {
        this.openVirtual(studentInfo);
        this.routeStateService.virtualPageUpdate(null);
      }
    });

    this.routeStateService.virtualPageStatu.subscribe(statu => {

      if (statu == "close") {
        this.closeVirtual();
      }
    });

    this.getScreenSize();
  }

  @HostListener('window:resize', ['$event'])

  getScreenSize(event?) {
    
    if(window.innerWidth >= 992){
      this.scrHeight = window.innerHeight - 27;
    }
    else{
      this.scrHeight = window.innerHeight - 100;
    }
    
    this.scrWidth = window.innerWidth;
    
    
  }
  ///////////////
  bntStyle: string = "width";
  isBigBlueButtom: boolean = false;
  headerStyle: string = "float-right";
  urlVirtual;
  // urlVirtual: string = "https://canliders.jetsinif.com/";
  submit(event1, event2) {
    this.bntStyle = event1;
    this.headerStyle = event2;

    if(event1 == "left"){
      this.showSidebar();

    }
    else if(event1 =="width"){
      this.hideSidebar();
    }
    

  }

  openVirtual(url) {

    this.urlVirtual = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    this.isBigBlueButtom = true;
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });



    if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
      console.log("enumerateDevices() not supported.");
    } 
    else {

      var opts = { audio: true, video: true };
      navigator.mediaDevices.getUserMedia(opts);

      // List cameras and microphones.
      navigator.mediaDevices.enumerateDevices()
        .then(function (devices) {
          devices.forEach(function (device) {
            // console.log(device.kind + ": " + device.label +
            //   " id = " + device.deviceId);
          });
        })
        .catch(function (err) {
          console.log(err.name);
        });
    }

    setTimeout(() => {
      console.log("1");
       $('#iframe_page').contents().find('.buttonWrapper--x8uow').trigger("click");
    
    }, 6000);

  }
  closeVirtual() {
    this.isBigBlueButtom = false;
    this.routeStateService.virtualPageUpdate(null);
    this.showSidebar();
    this.bntStyle = "width";
    this.headerStyle = "float-right";
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }

  hideSidebar(){
    
    
    if (this.scrWidth >= 992) {
      $("#wrapper").addClass("toggled");
    }
  }

  showSidebar(){
    if (this.scrWidth >= 992) {
      $("#wrapper").removeClass("toggled");
      
    }
  }

}
